import { useState } from "react";
import { PageKonten5 } from './Page5';
import { PageKonten7 } from './Page7';
import { PageKonten8 } from './Page8';
import { PageKonten10 } from './Page10';
import { PageKonten11 } from './Page11';
import { PageKonten12 } from './Page12';
import { PageKonten31DaftarSuplier } from './Page31_daftarSuplier';
import { PageKontenUkuranBan } from './PageUkuranBan';

//KONTAINER TAB
export function PageKonten6({globalOpsi, authIdentity = {}, token, onMasterChanged}) {
  const [activeTab, setActiveTab] = useState("tab1");
  const sharedAuthProps = { authIdentity };
  
  const tabs = [
    { id: "tab1", label: "Wilayah" },
    { id: "tab2", label: "Cabang" },
    { id: "tab3", label: "Merk Ban" },
    { id: "tab4", label: "Kapasitas" },
    { id: "tab5", label: "Kategori" },
    { id: "tab6", label: "Merk Kendaraan" },
    { id: "tab7", label: "Suplier" },
    { id: "tab8", label: "Ukuran Ban" },
  ];

  return (
    <div className="page-con-tabh master-page">
      <div className="otf-header">
        <div>
          <h2 className="otf-title">Atribute Data</h2>
        </div>
      </div>

      <div className="container-con-tabh master-shell">
        <div className="col-md-2 master-tabs-vertical">
          {tabs.map(tab => (
            <button
              type="button"
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`master-tab-btn ${activeTab === tab.id ? "is-active" : ""}`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="master-content">
          {activeTab === "tab1" && <PageKonten7 token={token} globalOpsi={globalOpsi} {...sharedAuthProps} />}
          {activeTab === "tab2" && <PageKonten8 token={token} globalOpsi={globalOpsi} {...sharedAuthProps} />}
          {activeTab === "tab3" && <PageKonten5 token={token} globalOpsi={globalOpsi} {...sharedAuthProps} />}
          {activeTab === "tab4" && <PageKonten10 token={token} globalOpsi={globalOpsi} {...sharedAuthProps} />}
          {activeTab === "tab5" && <PageKonten11 token={token} globalOpsi={globalOpsi} {...sharedAuthProps} />}
          {activeTab === "tab6" && <PageKonten12 token={token} globalOpsi={globalOpsi} {...sharedAuthProps} />}
          {activeTab === "tab7" && <PageKonten31DaftarSuplier token={token} globalOpsi={globalOpsi} {...sharedAuthProps} />}
          {activeTab === "tab8" && <PageKontenUkuranBan token={token} onMasterChanged={onMasterChanged} {...sharedAuthProps} />}
        </div>
      </div>
    </div>
  );
}
